export default "__VITE_ASSET__DL7Qeh6W__"